<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="buy-point-history">
      <Title eng="COIN HISTORY" :jpn="t('引換履歴&ポイント履歴')" />
      <HistoryTable
        v-if="dispHistoryList && dispHistoryList.length > 0"
        class="history-table"
        :historyList="dispHistoryList"
        :isCenterLink="true"
        :headerNameLeft="t('取引日')"
        :headerNameCenter="t('取引内容')"
        :headerNameRight="t('引換・付与ポイント')"
        bodyLeftKey="buyDate"
        bodyCenterKey="memo"
        bodyRightKey="bonusCoin"
        centerSize="108px"
        rightSize="68px"
        centerMargin="0 0 0 45px"
        rightMargin="0 0 0 41px"
        @center_click="center_click"
      />
      <div
        v-if="!(dispHistoryList && dispHistoryList.length > 0)"
        class="no-history"
      >
        <span>{{t('引換履歴&ポイント履歴がありません。')}}</span>
      </div>
      <BoxPager
        v-if="dispHistoryList &&
          dispHistoryList.length > 0 &&
          coinHistoryList &&
          coinHistoryList.page.pages.length > 0
        "
        class="box-pager"
        :totalPageCount="coinHistoryList.page.all_page"
        :currentPageCount="coinHistoryList.page.page"
        :dispBoxCount="coinHistoryList.page.pages.length"
        :pages="coinHistoryList.page.pages"
        @handlePagerClick="changeCurrentPageCount"
        @handleSquareBtnClick="changeCurrentPageCount"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateDecimalNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import HistoryTable from '@/components/organisms/HistoryTable.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CoinHistory',
  mixins: [t],

  components: {
    BaseTemplate,
    HistoryTable,
    BoxPager,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      coinHistoryList: 'coinHistory/coinHistoryList',
    }),
    dispHistoryList() {
      if (this.coinHistoryList) {
        if (this.coinHistoryList.list.length > 0) {
          const dispHistoryList = this.coinHistoryList.list.reduce((acc, cur) => {
            const {
              id, bonusCoin, money, created, memo,
            } = cur;
            const historyId = cur.history_id;
            const buyDate = created.split(' ')[0].slice(2);
            acc.push({
              id,
              buyDate,
              historyId,
              isCenterLink: bonusCoin <= 0 && historyId > 0,
              memo,
              bonusCoin: `${separateDecimalNumber(bonusCoin)}`,
              money: `${separateDecimalNumber(money)}${this.t('円')}`,
            });
            return acc;
          }, []);
          return dispHistoryList;
        }
      }
      return [];
    },
  },

  created() {
    const pageNumber = 1;
    this.$store.dispatch('coinHistory/setCoinHistoryList', { pageNumber });
  },

  methods: {
    changeCurrentPageCount(pageNumber) {
      this.$store.dispatch('coinHistory/setCoinHistoryList', { pageNumber });
    },
    center_click(row) {
      if (!row.isCenterLink) {
        return;
      }
      const packHistoryId = row.historyId;
      (async () => {
        // const query = {
        //   packHistoryId,
        // };
        await this.$store.dispatch('packHistory/setCurrentPackHistory', { packHistoryId });
        const currentPackHistory = this.$store.getters['packHistory/currentPackHistory'];
        const isDivision = currentPackHistory.status === '1';
        if (isDivision) {
          this.$router.push('/');
        } else {
          this.$router.push('/get-card-list');
        }
      })();
    },
  },
};
</script>

<style lang="scss" scoped>
$pagerWidth: 100%;

.buy-point-history{
  position: relative;
  width: 100%;
  max-width: 800px;
  padding: 30px 20px 90px;
  margin: 0px auto;
  @media screen and (min-width:767px){
    max-width: 580px;
  }
  @media screen and (min-width:1023px){
    max-width: 1400px;
  }
  .point_buy_area {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }
  .buy-point-history-title{
    display: flex;
    justify-content: center;
    .text{
      height: 44px;
      font-family: $notoSerif;
      font-size: 30px;
      font-weight: 700;
      color: $deepGray;
      text-shadow: $titleShadow;
    }
  }
  .history-table{
    width: 100%;
    margin-top: 30px;
  }
  .box-pager{
    width: $pagerWidth;
    height: 30px;
    margin: 0px auto;
  }
  .no-history{
    margin-top: 20px;
    font-family: $notoSans;
    font-size: 14px;
    line-height: 2.25;
    color: $deepGray;
    text-align: center;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .buy-point-history {
    padding: 30px 0 30px;
    .history-table {
      margin-top: 10px;
      margin-bottom: 30px;
    }
  }
}
</style>
